import React,{useState,useEffect} from "react";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
import Mute from '../images/Mute.svg';
import NoMute from '../images/Speaker.svg';
import speakerClick from "../images/speaker-Click.svg";
import muteBlue from "../images/muteblue.svg";
import ReactGA from "react-ga4";

const Input = styled(MuiInput)`
  width: 42px;
`;

const preloadSrcList = [
    Mute,
    NoMute,
    speakerClick,
    muteBlue
]

export default function SoundItem(props){

    //UseState for Likes button
    const [sound, setsound] = useState(false)
    const [value, setValue] = React.useState(100);
    const [beforMuteValue, setBeforMuteValue] = React.useState(100);
  
    const [clickMode, setClickMode ] = useState(false)

    useEffect(() => {
        preloadSrcList.forEach((image) => {
        new Image().src = image
        });
    }, []);

    let handleSliderChange = (event, newValue) => {
    setBeforMuteValue(value)
    if(newValue <= 0 ){
        setsound(false)
    }else{
        setsound(true)
    }
    setValue(newValue);
    props.audioChanged(newValue/100)
    };    
            
    const onMouseDownHandler = () => {
        setClickMode(true);
        // console.log("onMouseDown Event!");
    };

    const onMouseUpHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    const onMouseLeaveHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };


    return(
        <div className="sound-item"> 
            
            <Box sx={{ width: 250 }}>
                
                <Grid container spacing={3} alignItems="center">
                    <Grid item >
                    {(sound) ? 
                        <img src={(clickMode == true)? speakerClick :NoMute} onClick={() => {
                            handleSliderChange(null,0)
                            ReactGA.event({category: 'Engagement', action: "ui_soundOn" ,value: 1})
                        }} 
                            onMouseDown={onMouseDownHandler}
                            onMouseUp={onMouseUpHandler}
                            onMouseLeave={onMouseLeaveHandler}
                            onTouchMove={onMouseLeaveHandler}
                            onTouchCancel={onMouseLeaveHandler}
                            onTouchStart={onMouseDownHandler}
                            onTouchEnd={onMouseUpHandler}
                            alt="Logo" 
                            className={(clickMode == true)? "speaker-clicked-icon":"speaker--icon"}
                        />
                    :
                        <img src={(clickMode == true)? muteBlue :Mute} onClick={() => {
                                handleSliderChange(null,beforMuteValue)
                                ReactGA.event({category: 'Engagement', action: "ui_soundOff" ,value: 1})

                            }} 
                            onMouseDown={onMouseDownHandler}
                            onMouseUp={onMouseUpHandler}
                            onMouseLeave={onMouseLeaveHandler}
                            onTouchMove={onMouseLeaveHandler}
                            onTouchCancel={onMouseLeaveHandler}
                            onTouchStart={onMouseDownHandler}
                            onTouchEnd={onMouseUpHandler}
                            alt="Logo" 
                            className={(clickMode == true)? "speaker-clicked-icon":"speaker--icon"}
                        />
                    }
                    </Grid>
                    <Grid item xs>
    
                    </Grid>
                    
                </Grid>
            </Box>
        </div>
    )
}